import { render } from "./CursorTrail.vue?vue&type=template&id=785facc1"
import script from "./CursorTrail.vue?vue&type=script&lang=js"
export * from "./CursorTrail.vue?vue&type=script&lang=js"

import "./CursorTrail.vue?vue&type=style&index=0&id=785facc1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__